import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	var obj = {
		searchlist:[
				{
					label: "应税凭证税务编号",
					prop: "yingspzswbh",
					type: "input",
				},
				{
					prop: "yingspzbh",
					label: '应税凭证编号',
					type: "input",
				},
				{
					prop: "yingspzmc",
					label: '应税凭证名称',
					type: "input",
				},{
					prop: "shenbqxlx",
					label: '申报期限类型',
					type: "select",
					selectval:[
						{
							value:'0',label:'次'
						},
						{
							value:'2',label:'季'
						},
						{
							value:'4',label:'年'
						}
				],
				},{
					prop: "yingspzsl",
					label: '应税凭证数量',
					type: "input",
				},{
					prop: "suosqq",
					label: "税款所属期起止",
					type: "datetimerange",
					valueformat:'yyyy-MM-dd hh:mm:ss'
				},
				{
					label: "税目",
					prop: "shuim",
					type: "select",
					selectval:[{value:'123',label:'123'}],
					selectchange:true,
				},{
					label: "子目",
					prop: "zim",
					type: "select",
					selectval:[],

				},{
					label: "应纳税凭证书立日期",
					prop: "yingnspzsllsrq",
					type: "realdate",
				},
				// {
				// 	label: "计税金额",
				// 	prop: "jisje",
				// 	type:'input'
				// },
				{
					label: "实际结算日期",
					prop: "shijjsrq",
					type:'realdate'
				},
				// {
				// 	label: "实际结算金额",
				// 	prop: "shijjsje",
				// 	type:'input'
				// },
				// {
				// 	label: "税率",
				// 	prop: "shuil",
				// 	type:'input'
				// },
				// {
				// 	label: "应纳税额",
				// 	prop: "yingnse",
				// 	type:'input'
				// },
				// {
				// 	label: "减免性质代码和项目名称",
				// 	prop: "jianmxzdmhxmmc",
				// 	type:'input'
				// },
				// {
				// 	label: "减免税额",
				// 	prop: "jianmse",
				// 	type:'input'
				// },
				// {
				// 	label: "已缴款税额",
				// 	prop: "yijnse",
				// 	type:'input'
				// },
			],
		searchdata:{
			yingnse:'',
			jianmxzdmhxmmc:'',
			jianmse:'',
			yijnse:'',
			yingspzswbh:'',
			yingspzbh:'',
			yingspzmc:'',
			yingspzsl:'',
			shenbqxlx:'',
			suosqq:'',
			shuim:'',
			zim:'',
			jisje:'',
			shijjsrq:'',
			shijjsje:'',
			shuil:'',
			yingnspzsllsrq:'',
		},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headDatayhs: [{
				title: "税目",
				prop: "shuim",
				
				custom: true
			},
			{
				title: "子目",
				prop: "zim",
				
				custom: true
			},
			{
				title: "申报期限类型",
				prop: "shenbqxlx",
				
				custom: true
			},
			{
				title: "税率",
				prop: "shuil",
				
			},
		],
		headData: [{
				title: "序号",
				prop: "xh",
				width: "80",
				custom: true
			},{
				title: "创建人",
				width: 160,
				prop: "createBy",
				custom: true,

			},{
				title: "创建时间",
				width: 160,	custom: true,
				prop: "createTime",
			},{
				title: "修改人",
				width: 160,
				prop: "updateBy",	custom: true,
			},{
				title: "修改时间",
				width: 160,
				custom: true,
				prop: "updateTime",
			},
			{
				title: "应税凭证税务编号",
				prop: "yingspzswbh",	custom: true,
				width: "135"
			},
			{
				title: "应税凭证编号",
				prop: "yingspzbh",	custom: true,
				width: "110"
			},
			{
				title: "应税凭证名称",
				prop: "yingspzmc",
				width: 160,	custom: true,
				Required: true
			},
			{
				title: "申报期限类型",
				prop: "shenbqxlx",
				width: "120",
				Required: true,
				custom: true
			},
			{
				title: "应税凭证数量",
				prop: "yingspzsl",
				width: "120",
				Required: true,
				custom: true

			},
			{
				title: "税目",
				prop: "shuim",
				width: 160,
				
				Required: true,
				custom: true
			},
			{
				title: "子目",
				prop: "zim",
				width: 160,
				
				custom: true
			},
			{
				title: "税款所属期起",
				prop: "suosqq",
				width: "130",
				Required: true,
				custom: true
			},
			{
				title: "税款所属期止",
				prop: "suosqz",
				width: "130",
				Required: true,
				custom: true
			},
			{
				title: "应纳税凭证书立日期",
				prop: "yingnspzsllsrq",
				width: "160",
				Required: true,
				custom: true,
			},
			{
				title: "计税金额",
				prop: "jisje",
				width: 90,
				AmountFormat: true,
				Required: true,
				custom: true

			},
			{
				title: "实际结算日期",
				prop: "shijjsrq",
				width: "110",
				custom: true

			},
			{
				title: "实际结算金额",
				prop: "shijjsje",
				width: 110,
				AmountFormat: true,
				custom: true
				
			},
			{
				title: "税率",
				prop: "shuil",
				width: 90,
				Required: true,
				custom: true
			},
			{
				title: "应纳税额",
				prop: "yingnse",
				width: "90",
				AmountFormat: true,
				custom: true
				
			},
			{
				title: "减免性质代码和项目名称",
				prop: "jianmxzdmhxmmc",
				width: "220",
			},
			{
				title: "减免税额",
				prop: "jianmse",
				width: 100,
				AmountFormat: true,
				custom: true

			},
			{
				title: "已缴款税额",
				prop: "yijnse",
				width: 100,
				AmountFormat: true,
				custom: true
				
			},
			{
				title: "操作",
				prop: "cz",
				width: "150",
				fixed: "right",
				custom: true
			},
		],
		formlist: [{
				prop: "yingspzswbh",
				label: "应税凭证税务编号",
				type: "input",
				width: "220px",
				disabled: true,
			},
			{
				prop: "yingspzmc",
				label: "应税凭证名称",
				type: "input",
				width: "220px",
				isnotnull: true
			},
			{
				prop: "yingspzsl",
				label: "应税凭证数量",
				type: "input",
				width: "220px",
				isnotnull: true
			},
			{
				prop: "zim",
				label: "子目",
				type: "select",
				width: "220px",
				selectchange: true,
				disabled:false,
			},
			{
				prop: "suosqz",
				label: "税款所属期止",
				type: "date",
				width: "220px",
				valueformat: "yyyyMMdd",
				isdate: true,
				isnotnull: true,
				disabled: true,
			},
			{
				prop: "jisje",
				label: "计税金额",
				type: "input",
				width: "220px",
				slot: true,
				isnotnull: true,
				isnumber: true,
				inputinput: true
			},
			{
				prop: "shijjsje",
				label: "实际结算金额",
				type: "input",
				slot: true,

			},
			{
				prop: "yingnse",
				label: "应纳税额",
				type: "input",
				width: "220px",
				slot: true,
				isnotnull: true,
				inputinput: true,
				isnumber: true
			},
			{
				prop: "jianmse",
				label: "减免税额",
				type: "input",
				width: "220px",
				slot: true,
				isnumber: true,
				inputinput: true
			},
			{
				prop: "yijnse",
				label: "已缴税额",
				type: "input",
				slot: true,
				width: "220px",
				inputinput: true
			},
			{
				prop: "yingspzbh",
				label: "应税凭证编号",
				type: "input",
				width: "220px",
			},

			{
				prop: "shenbqxlx",
				label: "申报期限类型",
				type: "select",
				width: "220px",
				isnotnull: true,
				selectchange: true
			},
			{
				prop: "shuim",
				label: "税目",
				type: "select",
				width: "220px",
				selectval: comMapping.$smzm,
				isnotnull: true,
				selectchange: true
			},
			{
				prop: "suosqq",
				label: "税款所属期起",
				type: "date",
				width: "220px",
				isdate: true,
				isnotnull: true,
				valueformat: "yyyyMMdd",
				disabled: true,
			},
			{
				prop: "yingnspzsllsrq",
				label: "应税凭证书立日期",
				type: "date",
				width: "220px",
				isdate: true,
				isnotnull: true,
				valueformat: "yyyyMMdd",
				pickerchange: true
			},
			{
				prop: "shijjsrq",
				label: "实际结算日期",
				isdate: true,
				slot: true,
				type: "date",
			},
			{
				prop: "shuil",
				label: "税率",
				type: "input",
				width: "220px",
				slot: true,
				selectchange: true,
			},
			{
				prop: "jianmxzdmhxmmc",
				label: "减免性质代码和项目名称",
				type: "select",
				width: "220px",
				selectval: comMapping.$yhslist,
				selectchange: true
			},{
				prop: "liuslfse",
				label: "六税两免减免税额",
				type: "input",
				width: "220px",
				slot: true,
			},
			{
				prop: "yingbtse",
				label: "应补退税额",
				type: "input",
				width: "220px",
				slot: true,
				disabled: true,
			},
			
		],
		formdata: {
			yingspzswbh: "",
			yingspzmc: "",
			yingspzsl: "",
			zim: "",
			suosqz: "",
			jisje: "",
			shijjsje: "",
			yingnse: "",
			jianmse: "",
			yingspzbh: "",
			shenbqxlx: "0",
			shuim: "",
			suosqq: "",
			yingnspzsllsrq: "",
			shijjsrq: "",
			shuil: "",
			jianmxzdmhxmmc: "",
			yijnse: "",
			liuslfse:'',
			yingbtse:'',
		},
		headDatadiag: [{
				title: "对方书立名称",
				width: 160,
				
				prop: "duifslmc",
				custom: true
			},
			{
				title: "对方书立人纳税人识别号(统一社会信用代码)",
				width: 270,
				
				prop: "duifslrnsrsbh",
				custom: true
			},
			{
				title: "对方书立人涉及金额",
				width: 160,
				AmountFormat: true,
				
				prop: "duifslrsjje",
				custom: true
			},
			{
				title: "操作",
				width: "200",
				prop: "cz",
				custom: true
			},
		],
		headDatasj: [
			{
				title: "序号",
				prop: "xh",
				custom: true,
			},
			{
				title: "实际结算日期",
				prop: "shijjsrq",
				width: "250px",
				custom: true,
				Required: true
			},
			{
				title: "实际结算金额",
				prop: "shijjsje",
				width: "150px",
				custom: true,
				Required: true
			},
		],
		headDatasb: [{
				title: "选择",
				prop: "choose",
				custom: true
			},
			{
				title: "税目",
				prop: "shuimName",
				width: "100",
			},
			{
				title: "子目",
				prop: "zimName",
				width: "100",
			},
			{
				title: "申报期限类型",
				prop: "shenbqxlx",
				width: "120px",
				custom: true
			},
			{
				title: "税率",
				prop: "shuil",
				width: "100",
				custom: true
			},
		]
	}
	return obj
}
